/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListAzureRegions200Response {
  /**
  * List of available Azure regions
  */
  'regions': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "regions",
      "baseName": "regions",
      "type": "Array<string>",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return ListAzureRegions200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

